/*
 * @Author: jy_liuxiaobo 1007157597@qq.com
 * @Date: 2022-12-22 10:53:17
 * @LastEditors: jacky
 * @LastEditTime: 2025-02-27 16:27:08
 * @FilePath: /zl_api_private_web/src/api/export.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "@/axios";
function exportExcel(url, data) {
  let formEl = document.createElement("form");
  formEl.id = "form";
  formEl.method = "post";
  formEl.enctype = "multipart/form-data";
  for (var key in data) {
    let inputEl = document.createElement("input");
    inputEl.type = "hidden";
    inputEl.name = key;
    inputEl.value = data[key];
    formEl.appendChild(inputEl);
  }
  document.body.appendChild(formEl);
  formEl.action = axios.defaults.baseURL + url;
  formEl.submit();
  document.body.removeChild(formEl);
}

/**
 * 网抓数据下载
 */
export function uploadDetailExport(flow_upload_id) {
  exportExcel("admin/webscrap/uploadDetailExport", { flow_upload_id });
}

/**
 * 下载批量映射的模板
 */
export function exportTemplate() {
  exportExcel("admin/email/exportTemplate", {});
}

/**
 * 下载  临时抓取任务-批量导入任务 的模板
 */
export function exportModel() {
  exportExcel("admin/temporary/exportModel", {});
}

/**
 * 下载商业公司历史月
 */
export function exportHistoryReriodMonth(paramater) {
  exportExcel("admin/history_reriod_month/export", {
    data: JSON.stringify(paramater),
  });
}


/**
 * 导出直连
 */
export function exportPluginPageList(paramater) {
  exportExcel("admin/plugin/pluginPageListExport",  paramater );
}


/**
 * 导出旧网抓
 */
 export function exportWebScrapLog(paramater) {
  exportExcel("admin/webscrap/exportWebScrapLog", 
   paramater
  );
}

/**
 * 导出新网抓
 */
 export function exportNewWebScrapLog(paramater) {
  exportExcel("admin/webscrap/exportNewWebScrapLog", 
   paramater
  );
}

/**
 * 获取文件拆分的商业公司导出接口
 */
 export function exportSplitfile(paramater) {
  exportExcel("admin/splitfile/export", 
   paramater
  );
}

/**
 * 直连文件下载
 */
 export function downloadLogFile(paramater) {
  exportExcel("admin/uploadfilelog/downloadLogFile", 
   paramater
  );
}



/**
 * 操作日志下载
 */
 export function operateLogExport(paramater) {
  exportExcel("admin/operate_log/getPage", 
   paramater
  );
}


